<template>
  <div class="content">
    <img src="../../assets/agreement/1.png" alt="" />
    <img src="../../assets/agreement/2.png" alt="" />
    <img src="../../assets/agreement/3.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.content {
  display: flex;
  flex-direction: column;
}
</style>
